import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dab5adb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ss-arquivos-disponiveis"
}
const _hoisted_2 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ss-alinhar-centro" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ss-mensagem-impressao-preview" }, " Clique nos três pontinhos para imprimir ou baixar. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "adobe-dc-view" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return ((_ctx.state.visivel))
    ? (_openBlock(), _createBlock(_component_a_modal, {
        key: 0,
        visible: _ctx.state.visivel,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.visivel) = $event)),
        centered: "",
        width: "100%",
        "wrap-class-name": "full-modal",
        footer: null,
        title: null
      }, {
        closeIcon: _withCtx(() => []),
        default: _withCtx(() => [
          (_ctx.UtilitarioGeral.validaLista(_ctx.props.arquivos))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                ((_ctx.props.arquivos.length > 1))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_a_dropdown, null, {
                          overlay: _withCtx(() => [
                            _createVNode(_component_a_menu, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.arquivos, (arquivo, index) => {
                                  return (_openBlock(), _createBlock(_component_a_menu_item, {
                                    key: index,
                                    class: _normalizeClass(_ctx.state.indexArquivoEmVisualizacao === index?'ss-menu-preview-selecionado':''),
                                    onClick: ($event: any) => (_ctx.preVisualizarPdf(index))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(arquivo.nome), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class", "onClick"]))
                                }), 128))
                              ]),
                              _: 1
                            }),
                            _createTextVNode("> ")
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, { style: {"display":"flex","align-items":"center","gap":"10px"} }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.props.tituloVariosArquivos) + " ", 1),
                                _createVNode(_component_icone, { nome: "menu" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      }, 8, ["visible"]))
    : _createCommentVNode("", true)
}